/*
Copyright 2026 Element Creations Ltd.

SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial
Please see LICENSE in the repository root for full details.
*/

// Import before logging/analytics. Redirect credentials never remain in the URL.
export function captureJoinHandoff(
  href: string,
  replace: (url: string) => void,
): {
  code: string;
  roomId: string | null;
  userId: string | null;
  recordingId?: string | null;
  accountOnly?: boolean;
} | null {
  const url = new URL(href),
    index = url.hash.indexOf("?");
  if (index < 0) return null;
  const params = new URLSearchParams(url.hash.slice(index + 1)),
    code = params.get("handoff");
  if (!code) return null;
  const userId = url.searchParams.get("staffUser");
  const recordingId =
    url.pathname === "/record" ? url.searchParams.get("v") : undefined;
  const accountOnly=params.get("accountOnly")==="1";
  params.delete("accountOnly");
  params.delete("handoff");
  if (recordingId) url.searchParams.delete("staffUser");
  url.hash = params.size
    ? url.hash.slice(0, index) + "?" + params.toString()
    : url.hash.slice(0, index).replace(/^#$/, "");
  replace(url.href);
  return {
    code,
    ...(accountOnly?{accountOnly:true}:{}),
    roomId: params.get("roomId"),
    userId,
    ...(recordingId ? { recordingId } : {}),
  };
}
export const pendingJoinHandoff = captureJoinHandoff(
  window.location.href,
  (url) => window.history.replaceState(window.history.state, "", url),
);
